import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navItems } from '@/mocks/books';
import LanguageSwitcher from './LanguageSwitcher';
import LocalizedNavLabel from './LocalizedNavLabel';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/' || location.pathname === '/home';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-black/20 backdrop-blur-md h-[56px]'
          : 'bg-transparent h-[72px]'
      }`}
    >
      <div className="section-container h-full">
        <nav className="flex items-center justify-between h-full">
          <Link
            to="/"
            className="flex items-center gap-3 shrink-0 group"
          >
            <img
              src="https://storage.readdy-site.link/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/1b4ec386-92cf-4cf4-b2ad-72663a227370_compressed_logo.webp"
              alt="未境原創 VIJING"
              className={`transition-all duration-300 ${
                scrolled ? 'h-7 w-auto' : 'h-10 w-auto'
              }`}
            />
            <span className={`font-heading font-semibold tracking-wide whitespace-nowrap transition-all duration-300 ${
              scrolled ? 'text-sm' : 'text-lg'
            } ${
              scrolled || !isHome ? 'text-white' : 'text-white'
            }`}>
              未境原創 VIJING
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.id}
                to={item.href}
                className={`transition-all duration-300 whitespace-nowrap cursor-pointer rounded-md ${
                  scrolled ? 'px-2.5 py-1.5 text-xs' : 'px-3 py-2 text-sm'
                } font-label ${
                  location.pathname === item.href
                    ? 'text-white font-medium'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                <LocalizedNavLabel href={item.href} fallback={item.label} />
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-2">
            <a
              href="https://sonbook.net"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className={`font-label rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'px-3 py-1.5 text-xs'
                  : 'px-4 py-2 text-sm'
              } bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm`}
            >
              前往崧博出版
            </a>
          </div>

          <LanguageSwitcher />

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors cursor-pointer text-white hover:bg-white/10"
            aria-label="選單"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </nav>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-primary-900/95 backdrop-blur-md border-t border-white/10">
          <div className="section-container py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.id}
                to={item.href}
                className={`px-3 py-3 text-sm font-label rounded-md transition-colors cursor-pointer ${
                  location.pathname === item.href
                    ? 'text-white font-medium bg-white/10'
                    : 'text-white/70 hover:text-white hover:bg-white/10'
                }`}
              >
                <LocalizedNavLabel href={item.href} fallback={item.label} />
              </Link>
            ))}
            <a
              href="https://sonbook.net"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="mt-3 px-3 py-3 text-sm font-label rounded-full bg-white/20 text-white text-center hover:bg-white/30 transition-colors cursor-pointer"
            >
              前往崧博出版
            </a>
          </div>
        </div>
      )}
    </header>
  );
}